import app from './app';
import { getEnvValue, getExternalAssetFilePath } from './utils';

const defaultImageUrl = app.baseUrl + '/static/og_placeholder.png';

const meta = Object.freeze({
  promoteBlockscoutInTitle: '',
  og: {
    description: "Pione Mesh is a robust Layer 2 and cross-chain interoperability platform, empowering users with a comprehensive view of multi-network activities, cross-chain messaging, and asset transfers. Through its advanced and seamless infrastructure, users can effortlessly navigate the intricate web of interconnected blockchains, bridges, and decentralized applications.",
    imageUrl: defaultImageUrl,
  },
});

export default meta;